module.exports = __webpack_public_path__ + "img/20211120-130.6c8837a2.jpg";